export default {
      id: "envelope-usage",
      viewBox: "0 0 25 18",
      url: "/" + "sprite.svg#envelope",
      toString: function () {
        return this.url;
      }
    }